export const isDraftVarianceAction = (action = {}) => (
  ['draft', 'inherited_pending'].includes(action.saveStatus || action.status || 'draft')
);
